module.exports = __webpack_public_path__ + "img/grassland1.c6507733.jpeg";